import { render, staticRenderFns } from "./highProItem.vue?vue&type=template&id=13da4beb&scoped=true&"
import script from "./highProItem.vue?vue&type=script&lang=js&"
export * from "./highProItem.vue?vue&type=script&lang=js&"
import style0 from "./highProItem.vue?vue&type=style&index=0&id=13da4beb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da4beb",
  null
  
)

export default component.exports